module.exports = __webpack_public_path__ + "static/media/delete.da7b55cc.svg";